var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editPerson }
            },
            [_vm._v("Edit Member")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.person
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.person.staffId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.person.memberFirstName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Image URL")]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.person.memberImageUrl,
                        title: _vm.person.memberFirstName
                      }
                    },
                    [_vm._v(_vm._s(_vm.person.memberImageUrl))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Image")]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "table-thumbnail",
                    attrs: {
                      title: _vm.person.memberFirstName,
                      src: _vm.person.memberImageUrl
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Biography")]),
                _vm._v(" "),
                _c("td", [_c("p", [_vm._v(_vm._s(_vm.person.biography))])])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Display Order")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.person.displayOrder))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.person.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Member Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b29b0340", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b29b0340","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Persons/PersonDetails.vue
// module id = T6sN
// module chunks = 0